import listActions from 'src/modules/interaction/list/interactionListActions';
import InteractionService from 'src/modules/interaction/interactionService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';

const prefix = 'INTERACTION_DESTROY';

const interactionDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: interactionDestroyActions.DESTROY_STARTED,
      });

      await InteractionService.destroyAll([id]);

      dispatch({
        type: interactionDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.interaction.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/interaction');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: interactionDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: interactionDestroyActions.DESTROY_ALL_STARTED,
      });

      await InteractionService.destroyAll(ids);

      dispatch({
        type: interactionDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doChangeSelected([]));
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.interaction.destroyAll.success'),
      );

      getHistory().push('/interaction');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: interactionDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default interactionDestroyActions;
